class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.onStickyVariantChange = this.onStickyVariantChange.bind(this);
    this.onMainVariantChange = this.onMainVariantChange.bind(this);
    this.addEventListener("change", this.onStickyVariantChange);
    document.addEventListener("variant:change", this.onMainVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this.onMainVariantChange);
  }

  connectedCallback() {
    this.syncFromSelect();
  }

  get select() {
    return this.querySelector("select");
  }

  get form() {
    return document.getElementById(`product-sticky-form-${this.dataset.section}`);
  }

  get mainProductForm() {
    return document.getElementById(`product-form-${this.dataset.section}`);
  }

  get preorderEnabled() {
    return this.mainProductForm?.closest("product-form")?.dataset.preorderEnabled === "true";
  }

  onStickyVariantChange() {
    this.syncFromSelect();
  }

  onMainVariantChange(event) {
    if (String(event.detail?.sectionId) !== String(this.dataset.section)) return;

    const variant = event.detail?.variant;
    const purchaseState = event.detail?.purchaseState || "unavailable";
    if (!variant) {
      this.updateControls(null, purchaseState);
      return;
    }

    const option = this.select?.querySelector(`option[value="${variant.id}"]`);
    if (option && this.select) this.select.value = String(variant.id);
    this.updateControls(option, purchaseState, variant.id);
  }

  syncFromSelect() {
    const selectedOption = this.select?.selectedOptions?.[0];
    if (!selectedOption) return;

    const purchaseState = this.getPurchaseState(selectedOption);
    this.updateControls(selectedOption, purchaseState, selectedOption.value);
  }

  getPurchaseState(option) {
    if (!option) return "unavailable";
    if (option.dataset.available !== "true") return "soldout";

    const quantity = Number(option.dataset.inventoryQuantity);
    if (
      this.preorderEnabled &&
      Number.isFinite(quantity) &&
      quantity <= 0 &&
      option.dataset.inventoryPolicy === "continue"
    ) {
      return "preorder";
    }

    return "available";
  }

  updateControls(option, purchaseState, variantId) {
    const input = this.form?.querySelector('input[name="id"]');
    const button = this.form?.querySelector('[name="add"]');
    if (!input || !button) return;

    if (variantId) input.value = variantId;

    const disabled = purchaseState === "soldout" || purchaseState === "unavailable";
    button.disabled = disabled;
    button.dataset.variantAvailable = String(!disabled);
    button.dataset.variantId = variantId || "";

    const text = button.querySelector(".sticky-cart-button-text") || button;
    text.textContent = {
      available: window.variantStrings?.addToCart || "Add to cart",
      preorder: window.variantStrings?.preorder || "Preorder",
      soldout: window.variantStrings?.soldOut || "Sold out",
      unavailable: window.variantStrings?.unavailable || "Unavailable",
    }[purchaseState];

    const dynamicCheckout = this.form.querySelector(
      ".product-form__dynamic-checkout, .shopify-payment-button"
    );
    if (dynamicCheckout) dynamicCheckout.hidden = disabled;
  }
}

if (!customElements.get("sticky-variant-select")) {
  customElements.define("sticky-variant-select", StickyProVariantSelect);
}

function updateStickyCartVisibility() {
  document.querySelectorAll(".product__sticky[data-section]").forEach((stickyWrapper) => {
    const sectionId = stickyWrapper.dataset.section;
    const buyButtonForm = document
      .getElementById(`product-form-${sectionId}`)
      ?.closest("product-form");

    if (!buyButtonForm) {
      stickyWrapper.classList.remove("sticky");
      return;
    }

    const formBottom = buyButtonForm.getBoundingClientRect().bottom + window.scrollY;
    const shouldShow = window.scrollY > formBottom;
    stickyWrapper.classList.toggle("sticky", shouldShow);
  });

  const anyStickyVisible = Boolean(document.querySelector(".product__sticky.sticky"));
  document.body.classList.toggle("sticky__cart", anyStickyVisible);
}

window.addEventListener("scroll", updateStickyCartVisibility, { passive: true });
window.addEventListener("resize", updateStickyCartVisibility);
document.addEventListener("DOMContentLoaded", updateStickyCartVisibility);
